(($, win) => {
	"use strict";

	$.enhancer("locationAutoComplete",
		{
			settings: {
				mediaQuery: "(min-width: 768px)",
				initialized: false,
				minQueryCharLength: 2,
				element: null,
				focusTriggeredByMouseClick: false,
				mouseDownHappened: false,
				focusedTriggeredByClosed: false,
				currentFocus: -1
			},
			locationInputWrapper: null,
			locationInput: null,
			locationDropDownMenu: null,
			remoteLocationDropDownMenu: null,
            remoteLocationDropDownDefaultPanel: null,
			locationDropDownDefaultPanel: null,
			locationDropDownSearchPanel: null,
			locationIdInput: null,
            cityLocationId: null,
            locationListIdInput: null,
			resetButton: null,
			form: null,
			searchButton: null,
			init: function (el) {

				this.settings.element = $(el);
				this.settings.focusTriggeredByMouseClick = false;
				const mediaQuery = win.matchMedia(this.settings.mediaQuery);

				this.setupElements();
				this.bindEvents();
				this.settings.initialized = true;
			},
			setupElements: function () {
				this.locationInputWrapper = this.settings.element;
				this.locationInput = this.locationInputWrapper.find("input[type=search]");

				this.locationInput.attr("role", "combobox")
					.attr("aria-expanded", "false")
					.attr("aria-autocomplete", "both");

				this.remoteLocationInput = this.locationInputWrapper.find("input[type=checkbox]");
				this.locationDropDownMenu = this.locationInputWrapper.find(".dropdown-menu-location");

				this.locationDropDownMenu.attr("role", "listbox");

				if (!this.locationDropDownMenu.attr("id")) {
					this.locationDropDownMenu.attr("id", this.locationInput.attr("id") + "-dropdown");
				}

				this.locationInput.attr("aria-controls", this.locationDropDownMenu.attr("id"))

				this.locationDropDownDefaultPanel = this.locationDropDownMenu.find(".location-dropdown-default");
				this.remoteLocationDropDownMenu = this.locationInputWrapper.find(".dropdown-menu-remote");
				this.remoteLocationDropDownDefaultPanel = this.locationDropDownMenu.find(".location-dropdown-remote");

                this.locationDropDownSearchPanel = this.locationDropDownMenu.find(".location-dropdown-search");
				this.form = this.settings.element.closest("form");
				this.locationIdInput = this.form.find("[name=l]");
				this.locationListIdInput = this.form.find("[data-arrangementSearchBox-location]");
				this.resetButton = this.locationInputWrapper.find(".input-reset");
				this.searchButton = this.form.find("[type=submit]");

				this.announcer = $("<div>", {
					"class": "sr-only",
					"aria-live": "assertive"
				});

				this.settings.element.append(this.announcer);


			},
			bindEvents: function () {
				this.locationInput.on("keyup", $.utils.debounce(this.handleKeyUp, 100, this))
					.on("keypress", $.proxy(this.handleKeyPress, this))
					.on("focus", $.proxy(this.handleFocus, this))
					.on("focusout", $.proxy(this.handleFocusOut, this))
					.on("mousedown", $.proxy(this.handleMouseDown, this))
					.on("input", $.proxy(this.handleInput, this))
					.on("blur", $.proxy(this.handleBlur, this))
					.on("keydown", $.proxy(this.handleKeydown, this));
				this.locationDropDownMenu.on("click", "a", $.proxy(this.handleElementClick, this));
                this.remoteLocationDropDownMenu.on("click","div.remote-checkbox", $.proxy(this.handleRemoteLocationSelected, this));
				this.locationDropDownMenu.on("mousedown", "a", $.proxy(this.handleElementMousedown, this));
				this.locationDropDownMenu.on("keydown", $.proxy(this.handleKeydown, this));
				this.resetButton.on("click", $.proxy(this.resetButtonClick, this));
			},
			handleBlur: function () {
				this.settings.focusTriggeredByMouseClick = false;

				if (!this.settings.mouseDownHappened) {
					this.locationDropDownMenu.removeClass("show");
					this.locationInput.attr("aria-expanded", "false");
				}
				else {
					this.settings.mouseDownHappened = false;
				}
			},
			handleMouseDown: function (e) {
				// Stop click use focus instead to open dd when tabbing to field and preventing bug
				this.settings.focusTriggeredByMouseClick = true;
			},
			handleInput: function (e) {
				this.settings.currentFocus = -1;

				// Show default panel if x is pressed to reset the input field
				const query = e.currentTarget.value.trim();
				if (query.length < this.settings.minQueryCharLength) {
					this.locationDropDownDefaultPanel.removeClass("d-none");
					this.locationDropDownSearchPanel.addClass("d-none");

					// Clear search on location
					this.locationIdInput.val("");
				} else {
					if (!this.locationDropDownMenu.hasClass("show")) {
						this.locationInput.dropdown("show");
						this.locationInput.attr("aria-expanded", "true");
					}
				}

				let hasText = query.length > 0;

				this.resetButton.toggleClass("show", hasText)
					.attr("tabindex", hasText ? "0" : "-1")
					.attr("aria-hidden", hasText ? "false" : "true");
			},
			handleFocusOut: function (e) {
				if (this.locationIdInput.val() === "") {
					$("#location-input").val("");
				}
			},
			handleFocus: function (e) {
				// Show dropdown on focus if the user didn't click the input field
				// and id the dropdown isn't visible
				if (!this.settings.focusTriggeredByMouseClick && !this.locationDropDownMenu.hasClass("show")) {
					this.locationInput.dropdown("show");
				}

				this.locationDropDownMenu.addClass("show");
				this.locationInput.attr("aria-expanded", "true");
                this.remoteLocationDropDownMenu.removeClass("show");
				const query = e.currentTarget.value.trim();

				let hasText = query.length > 0;

				this.resetButton.toggleClass("show", hasText)
					.attr("tabindex", hasText ? "0" : "-1")
					.attr("aria-hidden", hasText ? "false" : "true");

			},
			handleKeyUp: function (e) {
				const query = e.currentTarget.value.trim();

				// Show/hide dropdowns when filtering from input
				if (query.length >= this.settings.minQueryCharLength) {
					const locationDropDownSearchPanel = this.locationDropDownSearchPanel;
					let count = 0;

					locationDropDownSearchPanel.empty();

					this.locationDropDownDefaultPanel.find("a").each(function () {
						const menuItem = $(this);
						const text = menuItem.text();

						if (menuItem.hasClass("dropdown-item-location") &&
							text.toLowerCase().startsWith(query.toLowerCase())) {
							const newMenuItem = menuItem.clone();
							const formatedText = $.utils.replaceString(newMenuItem.text(), query, `<b>$&</b>`);
							newMenuItem.html(formatedText);
							locationDropDownSearchPanel.append(newMenuItem);
							count++;
						}
					});

					if (count === 0) {
						locationDropDownSearchPanel.append(`<div class="dropdown-item"><i>Inga träffar för ${query}<i></div>`);
					}

					this.locationDropDownDefaultPanel.addClass("d-none");
					this.locationDropDownSearchPanel.removeClass("d-none");
				} else {
					this.locationDropDownDefaultPanel.removeClass("d-none");
					this.locationDropDownSearchPanel.addClass("d-none");
				}
			},
			handleKeyPress: function (e) {
				// Prevent form from being submitted on enter
				if (e.keyCode === 13) {
					e.preventDefault();
				}
			},
			handleKeydown: function (e) {
				const activeClass = "active-dropdown";

				const removeFocus = (links) => {
					$.each(links, function (i, link) {
						$(link).removeClass(activeClass);
					});
				}

				const addFocus = (links) => {
					removeFocus(links);

					if (this.settings.currentFocus >= links.length) {
						this.settings.currentFocus = 0;
					}

					if (this.settings.currentFocus < 0) {
						this.settings.currentFocus = (links.length - 1);
					}

					const currentLink = links.eq(this.settings.currentFocus);

					currentLink.addClass(activeClass);
					currentLink[0].scrollIntoView({
						block: 'nearest',
						inline: 'nearest'
					});

					console.log(currentLink.text())

					this.announce(currentLink.text());
				}

				let location = ".location-dropdown-default";

				if (this.locationDropDownSearchPanel.is(":visible")) {
					location = ".location-dropdown-search";
				}

				const links = $(location).find("a");

				if (this.locationInput.is(":focus")) {
					switch (e.keyCode) {
						// Arrow down
						case 40:
							this.settings.mouseDownHappened = true;
							this.settings.currentFocus++;

							addFocus(links);

							break;
						// Arrow up
						case 38:
							this.settings.mouseDownHappened = true;
							this.settings.currentFocus--;

							addFocus(links);

							break;
						// Enter
						case 13:
							if (this.settings.currentFocus > -1) {
								if (links) {
									links.eq(this.settings.currentFocus).trigger("click");
								}
							}

							break;
						// Escape
						case 27:
							this.locationDropDownMenu.removeClass("show");
							this.locationInput.attr("aria-expanded", "false");
							removeFocus(links);

							break;
						// Tab
						case 9:
							if (e.shiftKey) {
								break;
							}

							e.preventDefault();

							if (this.locationInput.val().length > 0) {
								this.resetButton.focus();
							}
							else {
								this.searchButton.focus();
							}

							break;
						default:
							break;
					}
				}
			},
			handleElementClick: function (e) {
				e.preventDefault();
				this.resetButton.addClass("show")
					.removeAttr("tabindex")
					.removeAttr("aria-hidden");

				const selectedElement = $(e.target).closest("a");
				const locationName = selectedElement.text().trim();

				const locationId = selectedElement.data("id");
                const remoteLocationId = 10851;
                this.cityLocationId = locationId;
				this.locationInput.val(locationName);
				this.locationInput.attr('value', locationName);
                this.locationListIdInput.val(locationId).trigger("change");
				this.locationDropDownMenu.removeClass("show");
				this.locationInput.attr("aria-expanded", "false");
				if (locationId !== remoteLocationId) {
                    this.remoteLocationDropDownMenu.addClass("show");
                }
            },
			handleRemoteLocationSelected: function (e) {

				e.preventDefault();

                const selectedElement = $(e.currentTarget.firstElementChild);

                if (selectedElement.is(':checked')) {
                    selectedElement.removeAttr("checked");
					this.locationListIdInput.val(this.cityLocationId).trigger("change");
                } else {
                    selectedElement.attr("checked",true);
                    this.locationListIdInput.val([this.locationListIdInput.val(),selectedElement.data("id")]);
				}
				selectedElement.trigger("change");
            },

			handleElementMousedown: function (e) {
				this.settings.mouseDownHappened = true;
			},
			resetButtonClick: function (e) {
				this.locationInput.val("").focus();
				this.locationListIdInput.val("").trigger("change");

				this.locationDropDownDefaultPanel.removeClass("d-none");
				this.locationDropDownSearchPanel.addClass("d-none");
                this.remoteLocationDropDownMenu.removeClass("show");
				this.locationInput.dropdown("show");
			},
			announce: function (text) {
				this.announcer.html(text);
			}
		});
})(jQuery, window);